<div class="data-table-container">
    <div class="table-header">
        <h4>{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.TITLE' | translate }}</h4>
        <div class="current-selection" *ngIf="selectedFrame">
            <span class="selection-time">{{ formatTime(selectedFrame.time) }}</span>
            <div class="selection-badge">
                <span class="type-badge" [ngStyle]="getFrameTypeBadgeStyle()">{{ getTypeDisplay() }}</span>
                <span class="response-value"
                    >{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.RESPONSE' | translate }}:
                    {{ selectedFrame.wave_data.amplitude | number: '1.2-2' }} mV</span
                >
            </div>
        </div>
    </div>

    <div class="measurement-table">
        <table class="details-table">
            <tbody>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.TYPE' | translate }}:</td>
                    <td class="value" [class.noise]="isNoise()">
                        {{ getTypeDisplay() }}
                    </td>
                </tr>
                <tr [class.hovered]="hoveredWaveIndex !== null">
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.AMPLITUDE' | translate }}:</td>
                    <td class="value">
                        {{ getHoveredAmplitudeDisplay() }}
                    </td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.DATE_TIME' | translate }}:</td>
                    <td class="value">{{ getDateTimeDisplay() }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.MODE' | translate }}:</td>
                    <td class="value">{{ getModeDisplay() }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.STIMULUS_CURRENT' | translate }}:</td>
                    <td class="value">{{ getStimulusCurrentDisplay() }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.PULSE_WIDTH' | translate }}:</td>
                    <td class="value">{{ getPulseWidthDisplay() }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.INTERVAL' | translate }}:</td>
                    <td class="value">{{ getIntervalDisplay() }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.LABELS.NOISE' | translate }}:</td>
                    <td class="value" [class.noise]="isNoise()">
                        {{ getNoiseDisplay() }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="no-selection" *ngIf="!selectedFrame">
        <p>{{ 'FEATURES.MEASUREMENTS.DATA_TABLE.NO_SELECTION' | translate }}</p>
    </div>
</div>
